import React, { useEffect } from 'react';
import { CgArrowTopRight } from "react-icons/cg";
import blogImg1 from "../assets/images/recentblog1.jpg"
import { Link, useParams } from 'react-router-dom';
import config from '../config';
import AOS from "aos";
import fpContent from '../JSONData/featuredProperties.json';

const FeaturedProperties = ({ customclasses, isShowTab = true, properties = [] }) => {

    useEffect(() => {
        AOS.init({});
        AOS.refresh();
    }, []);
    const { lang } = useParams();
    const labels = (fpContent && fpContent[lang]) ? fpContent[lang] : fpContent.en;

    const getProjectUrl = (slug) => {
        return lang ? `/${lang}/project/${slug}` : `/project/${slug}`;
    };

    return (
        <>
            <div className={`featured-property-section ${customclasses}`}>
                <div className='container'>{isShowTab === true ?
                    <div className='property-filters d-ps-50'>
                        <h3 className='h5'>{labels.byType}</h3>
                        <div className='tab-buttons d-flex align-end gap-30'>
                            <div className='button tab-button active'>{labels.all}</div>
                            <div className='button tab-button'>{labels.commercial}</div>
                            <div className='button tab-button'>{labels.residential}</div>
                            <div className='button tab-button'>{labels.hospitality}</div>
                        </div>
                    </div> : <></>}
                    <div className='grid-blocks d-flex flex-wrap sm-flex-column row-gap-50 d-row-gap-80 d-col-gap-70 d-gap-50 featured-properties'>
                        {properties[5] ?
                            <div className='grid-block d-pt-130'>
                                <div className='featured-property-item layout-1 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[5]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[5]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                            <div className="summary-block pb-30 text-left pe-20 ps-30 d-pe-0 d-ps-50 position-relative">
                                                <div className='h6 mb-15'>

                                                    {properties[5]?.location ? properties[5]?.location === 'undefined' ? '' : properties[5]?.location : ''}
                                                </div>
                                                <div className='h2 fw-300 mb-15'>{properties[5]?.title}</div>
                                                <Link to={getProjectUrl(properties[5]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>
                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div> : <></>}
                        {properties[6] ?
                            <div className='grid-block'>
                                <div className='featured-property-item layout-2 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[6]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[6]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                        </div>
                                    </Link>
                                    <div className="summary-block text-left position-relative pt-30 d-pt-40">
                                        <div className='h6 mb-15'>
                                            {/* {properties[6]?.location} */}
                                            {properties[6]?.location ? properties[6]?.location === 'undefined' ? '' : properties[6]?.location : ''}
                                        </div>
                                        <div className='h2 fw-300 mb-15'>{properties[6]?.title}</div>
                                        <Link to={getProjectUrl(properties[6]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>

                                    </div>
                                </div>
                            </div> : <></>}
                        {properties[7] ?

                            <div className='grid-block d-pt-130'>
                                <div className='featured-property-item layout-2 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[7]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[7]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                        </div>
                                    </Link>
                                    <div className="summary-block text-left position-relative pt-30 d-pt-40">
                                        <div className='h6 mb-15'>
                                            {/* {properties[7]?.location} */}
                                            {properties[7]?.location ? properties[7]?.location === 'undefined' ? '' : properties[7]?.location : ''}

                                        </div>
                                        <div className='h2 fw-300 mb-15'>{properties[7]?.title}</div>
                                        <Link to={getProjectUrl(properties[7]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>
                                    </div>
                                </div>
                            </div>
                            : <></>
                        }
                        {properties[8] ?
                            <div className='grid-block '>
                                <div className='featured-property-item layout-1 w-100' data-aos="fade-up" data-aos-delay="100" data-aos-duration="1000">
                                    <Link to={getProjectUrl(properties[8]?.slug)}>
                                        <div className='image-block position-relative overlay d-flex align-end justify-start'>
                                            <img src={config?.BASE_URL + properties[8]?.featuredImage} className='cover position-absolute top-0 start-0' />
                                            <div className="summary-block pb-30 text-left pe-20 ps-30 d-pe-0 d-ps-50 position-relative">
                                                <div className='h6 mb-15'>
                                                    {/* {properties[8]?.location} */}

                                                    {properties[8]?.location?properties[8]?.location==='undefined'?'':properties[8]?.location:''  }
                                                </div>
                                                <div className='h2 fw-300 mb-15'>{properties[8]?.title}</div>
                                                <Link to={getProjectUrl(properties[8]?.slug)} className='button gap-10'>{labels.viewMore}<CgArrowTopRight /></Link>

                                            </div>
                                        </div>
                                    </Link>
                                </div>
                            </div> : <></>
                        }

                    </div>
                    {((properties[5]) && (!properties[6]) && (!properties[7]) && (!properties[8])) ?
                        <div className='section-title d-flex justify-end '>
                            <div className="summary-block text-right">
                                <div className='h3 fw-300 mb-10'>{labels.exploreAll}</div>
                                <Link to='/project_index' className='button gap-10'>{labels.viewAll}<CgArrowTopRight /></Link>
                            </div>
                        </div> : <></>}

                    {((properties[5]) && (properties[6]) && (!properties[7]) && (!properties[8])) ?
                        <div className='section-title d-flex justify-end has-2-property'>
                            <div className="summary-block text-right">
                                <div className='h3 fw-300 mb-10'>{labels.exploreAll}</div>
                                <Link to='/project_index' className='button gap-10'>{labels.viewAll}<CgArrowTopRight /></Link>
                            </div>
                        </div> : <></>}
                    {((properties[5]) && (properties[6]) && (properties[7]) && (!properties[8])) ?
                        <div className='section-title d-flex justify-end '>
                            <div className="summary-block text-right">
                                <div className='h3 fw-300 mb-10'>{labels.exploreAll}</div>
                                <Link to='/project_index' className='button gap-10'>{labels.viewAll}<CgArrowTopRight /></Link>
                            </div>
                        </div> : <></>}

                    {((properties[5]) && (properties[6]) && (properties[7]) && (properties[8])) ?
                        <div className='section-title d-flex d-justify-end has-4-property'>
                            <div className="summary-block d-text-right">
                                <div className='h3 fw-300 mb-10 sm-hide'>{labels.exploreAll}</div>
                                {/* <Link to='/project_index' className='button gap-10 sm-hide'>view all<CgArrowTopRight /></Link> */}
                                <Link to='/project_index' className='button gap-10 border-bottom border-light'>{labels.viewAllProjects}</Link>
                            </div>
                        </div> : <></>}
                </div>
            </div>
        </>
    )
}

export default FeaturedProperties